import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowsDownUpStyle0 = gravityIconIndividualCss;

const GravityIconArrowsDownUp = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7cbf8027657b453188a5f9670716993d572c4326', color: this.color, size: this.size }, h("svg", { key: 'e76fba863af7ef4f2babf80edab56b479aa0e64d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd2eb61e6d3f1dd975fa332a200a3e3016421f2fd', d: "M15.683 7.874h2.284a.4.4 0 0 0 .283-.683l-3.034-3.034a.4.4 0 0 0-.566 0l-3.034 3.034a.4.4 0 0 0 .283.683h2.284v9.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-9.5Zm-7.869 6.251h2.284a.4.4 0 0 1 .283.683l-3.034 3.034a.4.4 0 0 1-.566 0l-3.034-3.034a.4.4 0 0 1 .283-.683h2.284v-9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v9.5Z", fill: "currentColor" }))));
    }
};
GravityIconArrowsDownUp.style = GravityIconArrowsDownUpStyle0;

export { GravityIconArrowsDownUp as gravity_icon_arrows_down_up };

//# sourceMappingURL=gravity-icon-arrows-down-up.entry.js.map